import { useState } from 'react';
import { type Waiting, addDays, capitalize, fmtRelativeDay, localToday, nextBusinessDay } from '@quadro/domain';
import { Sheet, SheetFooter, useAutoFocus } from '../../components/Sheet';
import * as api from '../../data/api';
import { keys, useAction } from '../../data/queries';
import { closeSheet } from '../../state/sheets';
import { useWorkspace } from '../../state/workspace';

/** Ao mover para "Aguardando terceiros": quem e quando cobrar. */
export function WaitingSheet({ title, onConfirm }: { title: string; onConfirm: (w: Waiting) => void }) {
  const today = localToday();
  const [who, setWho] = useState('');
  const [date, setDate] = useState(nextBusinessDay(addDays(today, 3)));
  const ref = useAutoFocus<HTMLInputElement>();
  const go = () => { onConfirm({ who: who.trim() || 'Terceiros', followUpOn: date || null }); closeSheet(); };
  return (
    <Sheet onClose={closeSheet} label="Aguardando terceiros">
      <div className="sh-body"><h2>Aguardando terceiros</h2>
        <p className="muted" style={{ margin: '-8px 0 14px' }}>“{title}” vai esperar a resposta de alguém. Defina quando cobrar e o quadro avisa no dia.</p>
        <div className="form">
          <label htmlFor="wQuem">Quem</label>
          <input id="wQuem" ref={ref} placeholder="Ex.: Jurídico, fornecedor, cliente" maxLength={60} value={who} onChange={e => setWho(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') go(); }} />
          <label htmlFor="wCobrar">Cobrar em</label>
          <div className="pair"><input type="date" id="wCobrar" value={date} onChange={e => setDate(e.target.value)} /><span className="muted">{date ? capitalize(fmtRelativeDay(date, today)) : ''}</span></div>
        </div>
      </div>
      <SheetFooter><span className="grow" /><button className="btn" onClick={closeSheet}>Cancelar</button><button className="btn primary" onClick={go}>Mover</button></SheetFooter>
    </Sheet>
  );
}

/** Limite de tarefas em Fazendo (WIP). */
export function WipSheet() {
  const ws = useWorkspace();
  const [v, setV] = useState(String(ws.settings.wipLimit));
  const ref = useAutoFocus<HTMLInputElement>(true);
  const save = useAction(api.saveWipLimit, [keys.settings]);
  const go = () => { save(Math.max(1, Math.min(50, Number(v) || ws.settings.wipLimit))); closeSheet(); };
  return (
    <Sheet onClose={closeSheet} label="Limite de Fazendo">
      <div className="sh-body"><h2>Limite de Fazendo</h2>
        <p className="muted" style={{ margin: '-8px 0 14px' }}>Quantas tarefas a equipe consegue tocar ao mesmo tempo sem perder ritmo. Vale para todos.</p>
        <div className="form"><label htmlFor="wipIn">Limite</label><input type="number" id="wipIn" ref={ref} min={1} max={50} style={{ width: 90 }} value={v} onChange={e => setV(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') go(); }} /></div>
      </div>
      <SheetFooter><span className="grow" /><button className="btn" onClick={closeSheet}>Cancelar</button><button className="btn primary" onClick={go}>Salvar</button></SheetFooter>
    </Sheet>
  );
}
